export default __webpack_public_path__ + "static/media/policies.195b4531.svg";